module.exports = __webpack_public_path__ + "static/media/carpediemVerticalLogo.793a9243.svg";